module.exports = __webpack_public_path__ + "static/media/lyfestyle_2.14494012.png";